import { RootState } from '@/store/types'
import {
  EvaluationInquiryApplicationsState,
  EvaluationInquiryApplication,
  EvaluationInquiryForAccept,
} from '@/store/applications/evaluationInquiries/types'
import axios from 'axios'
import { ActionTree } from 'vuex'
import _ from 'lodash'

const actions: ActionTree<EvaluationInquiryApplicationsState, RootState> = {
  /**
   * 評価問い合わせ申請取得
   *
   * @param {string} applicationId 申請ID
   */
  getEvaluationInquiryApplication: (
    { commit, dispatch, getters },
    { applicationId }: { applicationId: string },
  ) => axios.get(`/applications/inquiry/${applicationId}`).then(async ({ data }) => {
    await Promise.all([
      ..._.compact([
        data.tutorId,
      ]).map((tutorId) => dispatch('getTutor', { tutorId })),
      dispatch('getLessonByScheduleId', { scheduleId: data.lessonId }),
      dispatch('getStudentById', { studentId: data.studentId }),
    ])

    const application: EvaluationInquiryApplication = {
      id: applicationId,
      type: 'inquiry',
      inquiryType: data.taskType,
      student: getters.findStudentById(data.studentId),
      lesson: getters.findLessonByScheduleId(data.lessonId),
      comment: data.comment || null,
      applicant: {
        id: data.applicantId,
        name: data.applicantName,
      },
      status: data.status,
      approvedComment: _(data.events).maxBy('date')?.comment || null,
    }
    commit('gotEvaluationInquiryApplication', application)
  }),

  /**
   * 評価問い合わせ申請登録
   * @param context
   * @param {EvaluationInquiryApplication} payload 評価問い合わせ申請内容
   */
  registerEvaluationInquiryApplication: (
    context,
    application: EvaluationInquiryApplication,
  ) => axios.post('/applications/inquiry', {
    taskType: application.inquiryType,
    lessonId: application.lesson.scheduleId,
    studentId: application.student.id,
    comment: application.comment,
  }),

  /**
   * 評価問い合わせ申請後のクラスレコード評価修正承認
   * @param {EvaluationInquiryForAccept}
   */
  acceptClassRecordEvaluationWithInquiry: (
    context,
    { lessonId, studentId }: EvaluationInquiryForAccept,
  ) => axios.post(`/lessons/${lessonId}/grade/approval`, {
    studentId,
  }),

  /**
   * 評価問い合わせ申請後のFRS評価修正承認
   * @param {EvaluationInquiryForAccept}
   */
  acceptFrsEvaluationWithInquiry: (
    context,
    { lessonId, studentId }: EvaluationInquiryForAccept,
  ) => axios.post(`/lessons/${lessonId}/frsGrade/approval`, {
    studentId,
  }),
}

export default actions
